import styled from 'styled-components'

export const Restrict = styled.div`
	margin: 0 auto;
	max-width: ${props => props.extra ? "950px" : "1200px"};
`